(() => {
  'use strict';
  const params = new URLSearchParams(window.location.search);
  const leasePage = document.querySelector('[data-siti-lease]');
  const contact = document.querySelector('#sit-i-contact');
  const leaseRequest = Boolean(contact && params.get('aanvraag') === 'lease');
  if (!leasePage && !leaseRequest) return;

  // Read-only measurement: never intercept submission or alter the form/embed.
  const allowedModels = ['Opus', 'Care', 'Oris'];
  const context = () => {
    const requested = leasePage?.querySelector('[data-lease-model]')?.value || params.get('model');
    const payload = {
      language: document.documentElement.lang.startsWith('en') ? 'en' : 'nl',
      page_path: window.location.pathname,
      requested_model: allowedModels.includes(requested) ? requested : 'Productadvies'
    };
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(key => {
      const value = params.get(key);
      if (value && /^[a-zA-Z0-9_.-]{1,80}$/.test(value)) payload[key] = value;
    });
    return payload;
  };
  const analyticsAllowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const pending = [];
  const flush = () => {
    if (!analyticsAllowed()) return;
    while (pending.length) {
      const {name, payload} = pending.shift();
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({event: name, ...payload});
        const result = window.Shopify?.analytics?.publish(name, payload);
        result?.catch?.(() => {});
      } catch (_) { /* Measurement failure must never interrupt a request. */ }
    }
  };
  const record = (name, extra = {}) => {
    pending.push({name, payload: {...context(), ...extra}});
    flush();
  };
  document.addEventListener('visitorConsentCollected', flush);
  let privacyRequested = false;
  const loadPrivacy = () => {
    if (privacyRequested || window.Shopify?.customerPrivacy || !window.Shopify?.loadFeatures) return;
    privacyRequested = true;
    try {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], error => {
        if (!error) flush();
      });
    } catch (_) { /* Leave measurement disabled when consent cannot be checked. */ }
  };
  loadPrivacy();
  // Shopify's privacy API can finish loading after a deferred theme script.
  let attempts = 0;
  const readiness = window.setInterval(() => {
    loadPrivacy();
    flush();
    if (window.Shopify?.customerPrivacy || ++attempts >= 30) window.clearInterval(readiness);
  }, 500);

  if (leasePage) {
    record('siti_lease_page_view');
    leasePage.addEventListener('click', event => {
      const link = event.target.closest('[data-lease-cta]');
      if (!link || !leasePage.contains(link)) return;
      record('siti_lease_consult_click', {
        cta_position: link.closest('.siti-lease__final') ? 'footer' : 'hero'
      });
    });
  }
  if (!leaseRequest) return;

  let submitted = false;
  let completed = false;
  const confirmationVisible = () => {
    const node = contact.querySelector('._form-thank-you');
    if (!node || !node.textContent.trim() || !node.getClientRects().length) return false;
    const style = window.getComputedStyle(node);
    return style.visibility !== 'hidden' && style.display !== 'none';
  };
  contact.addEventListener('submit', event => {
    if (event.target.matches('form[action*="activehosted.com"]') && !confirmationVisible()) submitted = true;
  }, true);
  new MutationObserver(() => {
    if (!submitted || completed || !confirmationVisible()) return;
    completed = true;
    record('siti_lease_request_success');
  }).observe(contact, {childList: true, subtree: true, attributes: true, characterData: true});
})();
